var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesClientReports/SalesClientReport.scss";
import GenericSearch from "@frameworks/salesjourney/components/Generic/Search/GenericSearch";
import ReportingClientSearchResult from "./ReportingClientSearchResult";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import EdModal from "@frameworks/shared-library/components/edModal";
import SalesRating from "@frameworks/salesjourney/components/Generic/SalesRating";
import { getLocalISOString } from "@domains/utils/reportDates";
var SalesClientReport = function () {
    var _a = __read(React.useState(""), 2), searchedClient = _a[0], setSearchedClient = _a[1];
    var _b = __read(React.useState([]), 2), searchedClients = _b[0], setSearchedClients = _b[1];
    var _c = __read(React.useState(false), 2), isShowReportUI = _c[0], setIsShowReportUI = _c[1];
    var _d = __read(React.useState(false), 2), isShowSearchResults = _d[0], setIsShowSearchResults = _d[1];
    var _e = __read(useState(false), 2), showClientReportRating = _e[0], setShowClientReportRating = _e[1];
    var clientSearchData = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.data; });
    var commonClientSearchData = useSelector(function (state) { return state.Clients.ClientSearch.commonData; });
    var getClientSearchData = function (searchText) {
        setSearchedClients([]);
        clientDi.clients.getClientSearchData({ searchText: searchText });
    };
    var handleSelectedClient = function (selectedClientData) {
        setIsShowReportUI(false);
        handleRemoveFiltersFromSessionStorage();
        setSearchedClient(selectedClientData.clientName);
        sessionStorage.setItem("initialLoad", JSON.stringify(true));
        di.salesReporting
            .getSearchedClientJWTToken({ AccCode: selectedClientData.accountCode })
            .then(function (data) {
            if (!!data.jwtToken && data.jwtToken.length) {
                localStorage.setItem("sales_jwt_token", data.jwtToken);
                setIsShowReportUI(true);
                setIsShowSearchResults(false);
            }
            else {
                setIsShowReportUI(false);
            }
        })
            .catch(function (err) {
            setIsShowReportUI(false);
        });
    };
    var handleRemoveJWTFromStorage = function () {
        localStorage.removeItem("sales_jwt_token");
        localStorage.removeItem("accountCode");
    };
    var handleRemoveFiltersFromSessionStorage = function () {
        [
            "underlyingAsset",
            "expiryMonth",
            "instrumentType",
            "optionType",
            "strikePrice",
            "simpleFilter",
            "assetFilter",
        ].forEach(function (item) {
            sessionStorage.removeItem(item);
        });
    };
    var generateIFrameURL = function () {
        if (process.env.NODE_ENV === "production") {
            return "".concat(window.location.origin).concat(URLConfig.config.salesClientReport);
        }
        else {
            return URLConfig.config.salesClientReport;
        }
    };
    var getClientReportsRatingData = function (code) {
        profileDI.profile
            .getValidateFeedbackData({ submoduleCode: code })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.showFeedbackPopup) {
                setShowClientReportRating(true);
            }
            else {
                setShowClientReportRating(false);
            }
        })
            .catch(function (err) {
            setShowClientReportRating(false);
        });
    };
    var handleSubmitDashboardFeedback = function (ratingFlag, selectedStars, commentText) {
        profileDI.profile.saveDashboardFeedback({
            submodule_code: 4,
            rating_date: getLocalISOString(new Date()),
            rating_flg: ratingFlag,
            rating: selectedStars ? selectedStars : 0,
            remarks: commentText ? commentText : "",
        });
    };
    React.useEffect(function () {
        getClientReportsRatingData(4);
    }, []);
    React.useEffect(function () {
        setSearchedClients(clientSearchData);
    }, [clientSearchData]);
    React.useEffect(function () {
        if (!!!searchedClient && searchedClient.length === 0) {
            setIsShowReportUI(false);
            // handleRemoveFiltersFromSessionStorage();
            handleRemoveJWTFromStorage();
        }
        return function () { return handleRemoveJWTFromStorage(); };
    }, [searchedClient]);
    return (React.createElement(GridContainer, { parentClass: "client-reports-primary-container d-flex flex-column gap-3" },
        React.createElement("div", { className: "d-flex flex-column gap-2" },
            React.createElement("div", { className: "d-flex flex-column gap-2 client-reports-header-wrapper" },
                React.createElement("div", { className: "DMSan_28_700 d-flex align-items-center gap-2 txt-midnight-blue" },
                    React.createElement("span", null, "Client Reports")),
                React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey" }, "Search the client below to see their reports")),
            React.createElement(GenericSearch, { searchResultChild: React.createElement(ReportingClientSearchResult, { clientData: searchedClients, handleSelectClient: handleSelectedClient, searchLoader: commonClientSearchData.loader }), searchText: searchedClient, setSearchText: function (str) {
                    debounce(function () {
                        getClientSearchData(str);
                    });
                    setSearchedClient(str);
                }, parentClass: "justify-content-start", showSearchResults: isShowSearchResults, setShowSearchResults: setIsShowSearchResults })),
        !isShowReportUI ? (React.createElement("div", { className: "d-flex flex-column align-items-center gap-4 bg_white justify-content-center empty-screen-prompt-container" },
            React.createElement("i", { className: "edel-icon-user-avatar" },
                React.createElement("span", { className: "path1" }),
                React.createElement("span", { className: "path2" }),
                React.createElement("span", { className: "path3" })),
            React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey" }, "Search the client below to see their reports"))) : (React.createElement("iframe", { src: generateIFrameURL(), 
            // src={"https://openai.com"}
            className: "client-report-iframe", width: "100%" })),
        React.createElement("div", { className: "rating-modal" },
            React.createElement(EdModal, { show: showClientReportRating, setShow: function () {
                    setShowClientReportRating(false);
                    handleSubmitDashboardFeedback(false);
                }, showFooter: false, title: "Rate Us", children: React.createElement(SalesRating, { setShowSalesRating: setShowClientReportRating, ratingText: "How would you like to rate us on the Client Reports?", onSubmit: handleSubmitDashboardFeedback }), modalTitle: "", size: "modal-dialog-centered", hideCloseBtn: true }))));
};
export default SalesClientReport;
